module.exports = __webpack_public_path__ + "static/media/sync.6d92f8c8.svg";